/**
 * Wrapper that fetches patient data and renders PhoneNumbersModal.
 * @agentic connections
 */

import { PhoneNumbersModal } from "./PhoneNumbersModal";
import { usePatientResource } from "@/hooks/shared/useFHIRResource";
import { getActivePhoneNumbers } from "@benchmark/core/resolvers";
import { useMemo } from "react";
import type { Patient } from "@medplum/fhirtypes";

/**
 * Props for the phone numbers modal wrapper.
 * @agentic connections
 */
type PhoneNumbersModalWrapperProps = {
  opened: boolean;
  onClose: () => void;
  patientId: string;
};

/**
 * Fetches patient and renders PhoneNumbersModal.
 * @agentic connections
 */
export const PhoneNumbersModalWrapper = ({
  opened,
  onClose,
  patientId,
}: PhoneNumbersModalWrapperProps) => {
  const { data: patient, isLoading } = usePatientResource(patientId);
  const phoneNumbers = useMemo(
    () => (patient ? getActivePhoneNumbers(patient as Patient) : []),
    [patient],
  );

  if (isLoading || !patient) {
    return null;
  }

  return (
    <PhoneNumbersModal
      opened={opened}
      onClose={onClose}
      phoneNumbers={phoneNumbers}
      patientId={patientId}
    />
  );
};
